import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function PMGetAllTicketsDataService(token,data) {
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/PMGetAllTicketsData`, data, {
     
    headers: {
        'Authorization': token,
      }
    })
    .then(res => {
      notify.NotifySuccess("Tickets list fetched successfully.");
      return res.data;
    })
    .catch(error => {
      console.log(error);
      notify.NotifyError("An error occurred while fetching tickets details. please try again later.");
      return false;
    });
  }
  
  export default PMGetAllTicketsDataService;
  